import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Car } from "@phosphor-icons/react";
import { api } from "../lib/api";

const selCls = "w-full border border-slate-300 bg-white px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50 disabled:text-slate-400";

export const VehicleFinder = () => {
  const [vehicles, setVehicles] = useState([]);
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [year, setYear] = useState("");
  const [engine, setEngine] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/vehicles").then(({ data }) => setVehicles(data)).catch(() => {});
  }, []);

  const brandObj = vehicles.find((v) => v.brand === brand);
  const modelObj = brandObj?.models.find((m) => m.name === model);
  const engineObj = modelObj?.engines.find((e) => e.name === engine);
  const ready = brand && model && year && engine && engineObj;

  const go = () => {
    if (!ready) return;
    navigate(`/katalogs?skus=${engineObj.skus.join(",")}&vehicle=${encodeURIComponent(`${brand} ${model} ${year} ${engine}`)}`);
  };

  return (
    <section className="mx-auto max-w-7xl px-4 mt-6 relative z-10">
      <div data-testid="vehicle-finder" className="rounded-2xl border border-border bg-white p-6 shadow-[0_16px_48px_-16px_rgba(31,109,178,0.25)]">
        <p className="flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-[#1D1D1F]">
          <Car size={22} className="text-[#2E86D1]" /> Atrodi detaļas savai mašīnai
        </p>
        <div className="mt-4 grid grid-cols-1 md:grid-cols-4 gap-4">
          {[
            { label: "Marka", val: brand, testid: "vf-brand", disabled: false, opts: vehicles.map((v) => v.brand),
              set: (v) => { setBrand(v); setModel(""); setYear(""); setEngine(""); } },
            { label: "Modelis", val: model, testid: "vf-model", disabled: !brand, opts: brandObj?.models.map((m) => m.name) || [],
              set: (v) => { setModel(v); setYear(""); setEngine(""); } },
            { label: "Gads", val: year, testid: "vf-year", disabled: !model, opts: modelObj?.years || [],
              set: (v) => { setYear(v); } },
            { label: "Dzinējs", val: engine, testid: "vf-engine", disabled: !year, opts: modelObj?.engines.map((e) => e.name) || [],
              set: (v) => setEngine(v) },
          ].map((f) => (
            <div key={f.label}>
              <label className="text-xs font-semibold tracking-[0.15em] uppercase text-slate-500">{f.label}</label>
              <select data-testid={f.testid} value={f.val} disabled={f.disabled} onChange={(e) => f.set(e.target.value)} className={`mt-1.5 ${selCls}`}>
                <option value="">— izvēlies —</option>
                {f.opts.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </div>
          ))}
        </div>
        <button data-testid="vf-submit" onClick={go} disabled={!ready}
          className="btn-industrial mt-5 bg-[#2E86D1] px-6 py-3 text-sm font-semibold text-white hover:bg-[#1F6DB2] disabled:opacity-40">
          Rādīt derīgās detaļas
        </button>
      </div>
    </section>
  );
};
